// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"styles_heroImage__lh14L"};